import { ModelBase } from 'store/model-base';

export class LocationCollection extends ModelBase {
    public static storeName: string = 'cbmLocations';

    public header: string;
    public ctas: LocationCtas;
    public columnHeaders: LocationColumnHeaders;
    public locationRows: LocationRow[];

    public static create<T extends ModelBase>(data: ApiResponse = {}): T {
        data.locationRows?.forEach((locationRow: LocationRow) => {
            locationRow.isOrion = LocationCollection.isOrionAccount(locationRow.account);
        });

        return super.create<T>(data);
    }

    public static isOrionAccount(account?: string): boolean {
        return account?.toUpperCase().startsWith('OSITE_') || false;
    }
}
